// main imports
import * as React from "react";

// plugin imports

// style imports
import "./layout.scss";
import "../../styles/main.scss";

// svg imports

// components imports
import SmoothScroll from "./smoothScroll";
import Seo from "./seo";
import NavBar from "./menu/navBar/navBar";
import Footer from "./footer/footer";
import CookiesBanner from "./cookiesBanner/cookiesBanner";

// component
export default function Layout({ children, pageTitle }) {
	return (
		<SmoothScroll root={true}>
			<Seo title={pageTitle} />

			<NavBar />

			<main>{children}</main>

			<Footer />

			<CookiesBanner />
		</SmoothScroll>
	);
}
